'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require('reactstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Form obal - poskytuje context pro Fieldy (FieldGrid,...)
 */
var CustomForm = function (_React$Component) {
    (0, _inherits3.default)(CustomForm, _React$Component);

    function CustomForm() {
        (0, _classCallCheck3.default)(this, CustomForm);
        return (0, _possibleConstructorReturn3.default)(this, (CustomForm.__proto__ || (0, _getPrototypeOf2.default)(CustomForm)).apply(this, arguments));
    }

    (0, _createClass3.default)(CustomForm, [{
        key: 'getChildContext',
        value: function getChildContext() {
            var _props = this.props,
                horizontal = _props.horizontal,
                inline = _props.inline;


            return { horizontal: horizontal ? true : false, inline: inline ? true : false, form: true };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                form = _props2.form,
                horizontal = _props2.horizontal,
                other = (0, _objectWithoutProperties3.default)(_props2, ['form', 'horizontal']);


            return _react2.default.createElement(_reactstrap.Form, other);
        }
    }]);
    return CustomForm;
}(_react2.default.Component);

CustomForm.childContextTypes = {
    form: _react2.default.PropTypes.bool,
    horizontal: _react2.default.PropTypes.bool,
    inline: _react2.default.PropTypes.bool
};
exports.default = CustomForm;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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